const htmlModals = {
	namespaced: true,
	state: {
		modals: {
			createTag : false,
			conversation : false,
			editUser : false,
			createWorkspace : false,
			onboardingPages: false,
			onboardingInbox: false,
			onboardingUpcoming: false,
			pricingModal: false,
			upgradeModal: false,
			searchModal: false,
			automationRules: false,
			createTicket: false,
			connectionError: false,
			phoneRequest: false,
			sourceTitleRequest: false,
			authentication: false
		} 
	},
	getters: {
		modals(state){
			return state.modals
		}
	},
	mutations: {
		setPhoneRequestModal(state, data){
			state.modals.phoneRequest = data
		},
		setConversationModal(state, data){
			state.modals.conversation = data
		},
		setConnectionError(state, data){
			state.modals.connectionError = data
		},
		setConversationModalId(state, id){
			state.modals.conversationId = id
		},
		setOnboardingPages(state, data){
			state.modals.onboardingPages = data
		},
		setOnboardingInbox(state, data){
			state.modals.onboardingInbox = data
		},
		setOnboardingUpcoming(state, data){
			state.modals.onboardingUpcoming = data
		},
		setCreateWorkspace(state, data){
			state.modals.createWorkspace = data
		},
		setCreateSearchModal(state, data){
			state.modals.searchModal = data
		},
		setCreateTag(state, data){
			state.modals.createTag = data
		},	
		setTicketModal(state, data){
			state.modals.createTicket = data
		},	
		setEditUser(state, data){
			state.modals.editUser = data
		},
		setPricingModal(state, data){
			state.modals.pricingModal = data
		},
		setUpgradeModal(state, data){
			state.modals.upgradeModal = data
		},
		setAutomationRulesModal(state, data){
			state.modals.automationRules = data
		},
		setSourceTitleRequest(state, data){
			state.modals.sourceTitleRequest = data
		},
		setAuthenticationModal(state, data){
			state.modals.authentication = data
		}
	},
	actions: {
		setConnectionError({ commit }, data){
				commit('setConnectionError', data)
		},
		setConversationModal({ commit }, data){
				commit('setConversationModal', data)
		},
		setConversationModalId({ commit }, id){
				commit('setConversationModalId', id)
		},
		setOnboardingPages({ commit }, data){
				commit('setOnboardingPages', data)
		},
		setOnboardingInbox({ commit }, data){
				commit('setOnboardingInbox', data)
		},
		setOnboardingUpcoming({ commit }, data){
				commit('setOnboardingUpcoming', data)
		},
		setCreateWorkspace({ commit }, data){
				commit('setCreateWorkspace', data)
		},
		setCreateSearchModal({ commit }, data){
				commit('setCreateSearchModal', data)
		},
		setCreateTag({ commit }, data){
				commit('setCreateTag', data)
		},
		setTicketModal({ commit }, data){
				commit('setTicketModal', data)
		},
		setEditUser({ commit }, data){
				commit('setEditUser', data)
		},
		setPricingModal({ commit }, data){
				commit('setPricingModal', data)
		},
		setUpgradeModal({ commit }, data){
				commit('setUpgradeModal', data)
		},
		setAutomationRulesModal({ commit }, data){
				commit('setAutomationRulesModal', data)
		},
		setPhoneRequestModal({ commit }, data){
				commit('setPhoneRequestModal', data)
		},
		setSourceTitleRequest({ commit }, data){
				commit('setSourceTitleRequest', data)
		},
		setAuthenticationModal({ commit }, data){
				commit('setAuthenticationModal', data)
		}
	}
}

export default htmlModals;


// WEBPACK FOOTER //
// ./src/store/htmlModals.js